import React from "react";
import { useStoreState } from "easy-peasy";

export default function InformatiiAdminsitrativeTable() {
    let firmeConexe = useStoreState(
        state => state.companyProfile.companyProfile.firmeConexe
    );
    const storeFlag = useStoreState(s =>
        s && s.companyProfile ? s.companyProfile.isMoldovaEnvironment : undefined
    );

    const hostFlag =
        typeof window !== "undefined" && /\.md\b/i.test(window.location.hostname);

    const globalFlag =
        (typeof window !== "undefined" && window.__ENV_NAME__ === "Moldova") ||
        (typeof window !== "undefined" && localStorage.getItem("ENV_NAME") === "Moldova");

    const isMoldovaEnvironment =
        globalFlag ? true : (typeof storeFlag === "boolean" ? storeFlag : hostFlag);

    return firmeConexe && firmeConexe.length ? (
        <div className="card">
            <div className="card-header">
                <div className="row align-items-center">
                    <div className="col">
                        <h4 className="card-header-title">
                            {firmeConexe.length} firme conexe
                        </h4>
                    </div>
                    {!isMoldovaEnvironment && (
                        <div className="col-auto termene">
                            <h4 className="card-header-title text-muted">Sursă: termene.ro</h4>
                        </div>
                    )}
                </div>
            </div>
            <div className="d-none d-xs-none d-sm-none d-md-none d-lg-block">
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <button type="button" className="btn btn-link p-0 text-muted">
                                            Numele firmei
                                        </button>
                                    </th>
                                    <th scope="col">
                                        <button type="button" className="btn btn-link p-0 text-muted">
                                            {isMoldovaEnvironment ? "Raion" : "Județ"}
                                        </button>
                                    </th>
                                    <th scope="col">
                                        <button type="button" className="btn btn-link p-0 text-muted">
                                            Localitate
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="list">
                                {firmeConexe.map(item => (
                                    <tr key={item.cuiFirma}>
                                        <th>{item.numeFirma}</th>
                                        <td>{item.judet}</td>
                                        <td>{item.localitate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="d-xs-block d-sm-block d-md-block d-lg-none d-block">
                <div className="card-body">
                    {firmeConexe.map(item => (
                        <div key={item.cuiFirma} className="row">
                            <div className="col-12 pt-3 font-weight-bold">
                                {item.numeFirma}
                            </div>
                            <div className="col-12 pt-1">
                                {item.judet} | {item.localitate}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ) : (
        <div></div>
    );
}
